var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11667_67820)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    stroke: "#15C7A7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11667_67820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.50001V5.18501C4.50391 4.92653 4.55878 4.67135 4.66147 4.43411C4.76416 4.19687 4.91266 3.98222 5.09845 3.80247C5.28424 3.62272 5.50367 3.48139 5.74418 3.38659C5.98468 3.29179 6.24153 3.24538 6.5 3.25001V3.25001C6.75847 3.24538 7.01532 3.29179 7.25582 3.38659C7.49633 3.48139 7.71576 3.62272 7.90155 3.80247C8.08734 3.98222 8.23584 4.19687 8.33853 4.43411C8.44122 4.67135 8.49609 4.92653 8.5 5.18501V6.50001",
    stroke: "#15C7A7",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.75H4.25C4.3163 5.75 4.37989 5.77634 4.42678 5.82322C4.47366 5.87011 4.5 5.9337 4.5 6V7.5C4.5 7.5663 4.47366 7.62989 4.42678 7.67678C4.37989 7.72366 4.3163 7.75 4.25 7.75H3.75C3.61739 7.75 3.49021 7.69732 3.39645 7.60355C3.30268 7.50979 3.25 7.38261 3.25 7.25V6.25C3.25 6.11739 3.30268 5.99021 3.39645 5.89645C3.49021 5.80268 3.61739 5.75 3.75 5.75V5.75Z",
    stroke: "#15C7A7",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.75H8.75C8.6837 7.75 8.62011 7.72366 8.57322 7.67678C8.52634 7.62989 8.5 7.5663 8.5 7.5V6C8.5 5.9337 8.52634 5.87011 8.57322 5.82322C8.62011 5.77634 8.6837 5.75 8.75 5.75H9.25C9.38261 5.75 9.50979 5.80268 9.60355 5.89645C9.69732 5.99021 9.75 6.11739 9.75 6.25V7.25C9.75 7.38261 9.69732 7.50979 9.60355 7.60355C9.50979 7.69732 9.38261 7.75 9.25 7.75V7.75Z",
    stroke: "#15C7A7",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.125C7.76522 9.125 8.01957 9.01964 8.20711 8.83211C8.39464 8.64457 8.5 8.39022 8.5 8.125V7",
    stroke: "#15C7A7",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.125C7.5 9.29076 7.43415 9.44973 7.31694 9.56694C7.19973 9.68415 7.04076 9.75 6.875 9.75H6.125C5.95924 9.75 5.80027 9.68415 5.68306 9.56694C5.56585 9.44973 5.5 9.29076 5.5 9.125C5.5 8.95924 5.56585 8.80027 5.68306 8.68306C5.80027 8.56585 5.95924 8.5 6.125 8.5H6.875C7.04076 8.5 7.19973 8.56585 7.31694 8.68306C7.43415 8.80027 7.5 8.95924 7.5 9.125Z",
    stroke: "#15C7A7",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11667_67820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "matrix(-1 0 0 -1 13 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11667_67820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.703e0b22241d0a3328beb8ffe22ef1aa.svg";
export { ForwardRef as ReactComponent };